<div class="dashboard-productivity-info-wrapper">
    <div class="row dashboard-productivity-card-row">
        <div class="col-md-4 dashboard-productivity-card-col">
            <div class="card card-stretch h-100 rounded-0 context-menu dashboard-productivity-card">
                <div class="dashboard-productivity-card-header">
                    <div class="d-flex align-items-center">
                        <img src="../../../../assets/common/images/new-dashboard/DashboardProductivity.svg" class="h-20px w-20px" />
                        <div class="pl-3 font-weight-bolder h5 mb-0">
                            {{'Productivity'|localize}}
                        </div>
                    </div>
                </div>

                <div class="dashboard-productivity-chart-body">
                    <div *ngIf="applications == null || applications === undefined" class="dashboard-productivity-loader">
                        <ngx-shimmer-loading [width]="'260px'" [height]="'260px'" [shape]="'circle'"></ngx-shimmer-loading>
                    </div>

                    <div *ngIf="applications && (!areas || areas.length === 0)" class="dashboard-productivity-empty d-flex flex-column align-items-center justify-content-center w-100">
                        <img src="../../../../assets/common/images/time-off/empty-state-ui/my-time-off-empty-state.svg" class="img-fluid h-180px" />
                        <h6 class="text-muted mt-3 text-center">{{'NoDataFound' | localize}}</h6>
                    </div>

                    <div *ngIf="applications && areas && areas.length > 0" class="pies-container dashboard-productivity-chart-container" id="pies-container1">
                        <p-chart
                            type="doughnut"
                            [data]="areasPieChartData"
                            [options]="areasPieChartOptions"
                            [style]="chartHostStyle">
                        </p-chart>

                        <div class="center-circle" *ngIf="areas && areas.length > 0"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-4 dashboard-productivity-card-col">
            <div class="card card-stretch h-100 rounded-0 context-menu dashboard-productivity-card">
                <div class="dashboard-productivity-card-header">
                    <div class="d-flex align-items-center">
                        <img src="../../../../assets/common/images/new-dashboard/DashboardCategory.svg" class="h-20px w-20px" />
                        <div class="pl-3 font-weight-bolder h5 mb-0">
                            {{'Category'|localize}}
                        </div>
                    </div>
                </div>

                <div class="dashboard-productivity-chart-body">
                    <div *ngIf="applications == null || applications === undefined" class="dashboard-productivity-loader">
                        <ngx-shimmer-loading [width]="'260px'" [height]="'260px'" [shape]="'circle'"></ngx-shimmer-loading>
                    </div>

                    <div *ngIf="applications && (!prouctive || prouctive.length === 0)" class="dashboard-productivity-empty d-flex flex-column align-items-center justify-content-center w-100">
                        <img src="../../../../assets/common/images/time-off/empty-state-ui/my-time-off-empty-state.svg" class="img-fluid h-180px" />
                        <h6 class="text-muted mt-3 text-center">{{'NoDataFound' | localize}}</h6>
                    </div>

                    <div *ngIf="applications && prouctive && prouctive.length > 0" class="pies-container dashboard-productivity-chart-container">
                        <p-chart
                            type="pie"
                            [data]="categoryPieChartData"
                            [options]="categoryPieChartOptions"
                            [style]="chartHostStyle">
                        </p-chart>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-4 dashboard-productivity-card-col">
            <div class="card card-stretch h-100 rounded-0 context-menu dashboard-productivity-card">
                <div class="dashboard-productivity-card-header">
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="d-flex align-items-center">
                            <img src="../../../../assets/common/images/new-dashboard/Applications_Icon.svg" class="h-20px w-20px" />
                            <div class="pl-3 font-weight-bolder h5 mb-0">
                                {{'Application' |localize}}
                            </div>
                        </div>
                        <div *ngIf="applications?.length > 7" class="text-primary font-weight-bolder cursor-pointer">
                            <span (click)="viewAll()"> {{ 'ViewAll' | localize}}</span>
                        </div>
                    </div>
                </div>

                <div class="dashboard-application-list">
                    <div class="card border mt-3 dashboard-application-item" *ngFor="let app of [1,2,3,4,5,6,7]; trackBy: trackByIndex" [hidden]="applications != null && applications !== undefined">
                        <ngx-shimmer-loading [width]="'100%'" [height]="'30px'"></ngx-shimmer-loading>
                    </div>

                    <div *ngIf="applications && applications.length === 0" class="dashboard-productivity-empty d-flex flex-column align-items-center justify-content-center w-100">
                        <img src="../../../../assets/common/images/time-off/empty-state-ui/my-time-off-empty-state.svg" class="img-fluid h-180px" />
                        <h6 class="text-muted mt-3 text-center">{{'NoDataFound' | localize}}</h6>
                    </div>

                    <div class="card border mt-3 dashboard-application-item" *ngFor="let app of applications | slice:0:7 index as i; trackBy: trackByIndex">
                        <div *ngIf="i <= 7" class="card-body p-2 dashboard-application-item-body" (onHidden)="removeData()" containerClass="popTemplateClass"
                             (onShown)="GetData(app.applicationName)" ngbPopover="dd" data-toggle="popover" container="body" placement="bottom"
                             data-trigger="hover" data-html="true" [popover]="popTemplate2" #popTemplate="bs-popover"
                             triggers="mouseenter:mouseleave">
                            <div class="row align-items-center">
                                <div class="col-md-2">
                                    <img *ngIf="!LoadingStarted || app.applicationName!=HistoryForApp" src="{{app.icon ? app.icon : 'assets/common/images/timetracking/Empty-States Icon.svg'}}" 
                                     (error)="$any($event.target).src = 'assets/common/images/timetracking/Empty-States Icon.svg'"
                                     id="myElement" />
                                    <img *ngIf="LoadingStarted && app.applicationName==HistoryForApp" style="width: 25px;" src='assets/common/images/loading.gif'  id="myElement" />
                                </div>
                                <div class="col-md-5">
                                    <div class="h6 mt-1 mb-0">
                                        <span pTooltip="{{ app.applicationName }}" [tooltipDisabled]="_tus.showTooltipForString(app.applicationName, 20)" tooltipPosition="bottom">{{app.applicationName | slice:0:20}} {{app.applicationName.length > 20 ? '...' : ''}}</span>
                                    </div>
                                </div>
                                <div class="col-md-5 text-md-right">
                                    <small>
                                        {{'TimeSpend' |localize}}: {{ timerToMinsHrsSecs(app.spendTime)}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <ng-template #popTemplate2>
                            <div *ngIf="ShowDetails">
                                <div *ngFor="let app of HistoryDetails; trackBy: trackByIndex">
                                    <div class="row">
                                        <div class="col-md-10">
                                            <div class="h6">
                                                 <span>{{app.windowName}}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-2 d-flex pl-2">
                                            <small *ngIf="app.hours!=0">
                                                {{app.hours}}{{'h' | localize}}
                                            </small>
                                            <small *ngIf="app.minutes!=0">
                                                {{app.minutes}}{{'m' | localize}}
                                            </small>
                                            <small *ngIf="app.hours==0 && app.minutes==0">
                                                {{app.seconds}}{{'s' | localize}}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- Export to PDF/Excel popup Modal -->
<div class="modal" id="myModal1">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header border-0">
                <button type="button" class="close pull-right text-danger ml-auto py-2" aria-label="Close" data-dismiss="modal">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>

            <!-- Modal body -->
            <div class="modal-body pt-0">
                <div class="col-md-12 text-center p-3">
                    <img src="../../../../assets/common/images/users/ExportImageforModal.svg" class="img-fluid" />
                </div>
                <div class="col-md-12 text-center mt-4 text-dark-65">
                    <h4>{{'SelectExportOption'|localize}}</h4>
                    <div class="font-size-sm text-muted">{{'ChooseanoptionfromExcelandPDFtoexport'| localize}}</div>
                </div>

                <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-2"></div>
                    <div class="col-md-4"></div>
                </div>

                <div class="row mt-4">
                    <div class="col-md-6 mt-2">
                        <div class="p-3 border border-primary rounded d-flex justify-content-start align-items-center">
                            <img src="assets/common/images/users/1200px-PDF_file_icon.svg@2x.png" alt="logo" class="h-30px" />
                            <a class="cursor-pointer blue" (click)="exportToPdf($event)">
                                <div class="ml-4">
                                    <div>{{'ExportToPDF'|localize}}</div>
                                    <small class="text-muted">{{'ClickToexportListPdf' | localize}}</small>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 mt-2">
                        <div class="p-3 border border-primary rounded d-flex justify-content-start align-items-center">
                            <img src="assets/common/images/users/1200px-Microsoft_Office_Excel_(2018–present).svg@2x.png" alt="logo" class="h-30px" />
                            <a class="cursor-pointer blue" (click)="exportToExcel($event)">
                                <div class="ml-4">
                                    <div>{{'ExportToExcel'|localize}}</div>
                                    <small class="text-muted">{{'ClickToexportListExcel'|localize}}</small>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<p-drawer [(visible)]="isApplicationSidebarOpen"
          [blockScroll]="true"
          position="right"
          appendTo="body"
          (onHide)="hideApplicationSidebar()"
          styleClass="p-sidebar-md p-sidebar-bottom p-sidebar-zindex"
          id="dashboard-application-sidebar"
          [style]="{'overflow': 'auto'}"
          [autoZIndex]="true">
    <div class="h-100">
        <div class="rounded-0 h-100">
            <div class="h-100 col p-0">
                <div>
                    <h4 class="ml-4 mt-3">
                        <strong>{{ 'Application' | localize }}</strong>
                        <button type="button" class="close text-danger fs-2" (click)="hideApplicationSidebar()" aria-label="Close">
                            <i aria-hidden="true" class="ki ki-close"></i>
                        </button>
                    </h4>
                    <hr />
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="col-md-6 col-6 d-flex justify-content-start">
                        <div class="px-2 pb-0">
                            <div class="input-icon input-icon-right">
                                <input type="text"
                                       class="form-control intime-open-sans font-weight-bolder w-300px h-40px"
                                       [(ngModel)]="applicationSearchString"
                                       name="applicationFilterText"
                                       placeholder="{{ 'Search Application Name' | localize }}"
                                       (input)="filterApplications()" />
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17.207" height="17.207" viewBox="0 0 17.207 17.207">
                                        <path d="M17,17l-4.615-4.615m1.957-4.714A6.671,6.671,0,1,1,7.671,1,6.671,6.671,0,0,1,14.342,7.671Z" transform="translate(-0.5 -0.5)" fill="none" stroke="#b7b7b7" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="pr-3" *ngIf="applications?.length">
                        <export-dropdown (onSelectionChange)="onApplicationExportChange($event)" [disabled]="!applications?.length"></export-dropdown>
                    </div>
                </div>
                <div class="p-3">
                    <div *ngIf="applicationSidebarEmpty" class="d-flex flex-column align-items-center justify-content-center mt-20">
                        <img src="../../../../assets/common/images/time-off/empty-state-ui/my-time-off-empty-state.svg" class="img-fluid h-180px" />
                        <div class="text-muted font-size-lg mt-5">{{ 'NoDataFound' | localize }}</div>
                    </div>
                    <div *ngFor="let app of applicationsForSearch; trackBy: trackByIndex" class="card border mt-3">
                        <div class="card-body p-2"
                             (onHidden)="removeData()"
                             containerClass="popTemplateClass"
                             (onShown)="GetData(app.applicationName)"
                             data-toggle="popover"
                             container="body"
                             placement="bottom"
                             data-trigger="hover"
                             data-html="true"
                             [popover]="applicationSidebarPopover"
                             triggers="mouseenter:mouseleave">
                            <div class="row align-items-center">
                                <div class="col-md-2">
                                    <img *ngIf="!LoadingStarted || app.applicationName != HistoryForApp"
                                         src="{{ app.icon ? app.icon : 'assets/common/images/timetracking/Empty-States Icon.svg' }}"
                                         (error)="$any($event.target).src = 'assets/common/images/timetracking/Empty-States Icon.svg'"
                                         class="w-40px h-40px" />
                                    <img *ngIf="LoadingStarted && app.applicationName == HistoryForApp"
                                         src="assets/common/images/loading.gif"
                                         class="w-40px h-40px" />
                                </div>
                                <div class="col-md-6">
                                    <div class="h6 mb-0">{{ app.applicationName }}</div>
                                </div>
                                <div class="col-md-4 text-right">
                                    <small>{{ 'TimeSpend' | localize }}: {{ timerToMinsHrsSecs(app.spendTime) }}</small>
                                </div>
                            </div>
                        </div>
                        <ng-template #applicationSidebarPopover>
                            <div *ngIf="ShowDetails">
                                <div *ngFor="let history of HistoryDetails; trackBy: trackByIndex">
                                    <div class="row">
                                        <div class="col-md-9">
                                            <div class="h6">
                                                <span>{{ history.windowName }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <small *ngIf="history.hours != 0">{{ history.hours }}{{ 'h' | localize }}</small>
                                            <small *ngIf="history.minutes != 0">{{ history.minutes }}{{ 'm' | localize }}</small>
                                            <small *ngIf="history.hours == 0 && history.minutes == 0">{{ history.seconds }}{{ 's' | localize }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-drawer>
